/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free line sorter. Sort lines of text alphabetically, numerically, or by length — with reverse and case options. Runs in your browser.`)
};

const es_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenador de líneas gratuito. Ordena líneas de texto alfabética, numérica o por longitud, con opciones de inversión e insensibilidad a mayúsculas. Se ejecuta en tu navegador.`)
};

const de_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zeilensortierer. Sortieren Sie Textzeilen alphabetisch, numerisch oder nach Länge — mit Optionen für Umkehren und Groß-/Kleinschreibung. Läuft in Ihrem Browser.`)
};

const nl_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis regelsorteerprogramma. Sorteer regels tekst alfabetisch, numeriek of op lengte — met omgekeerde en niet-hoofdlettergevoelige opties. Werkt in uw browser.`)
};

const fr_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trieur de lignes gratuit. Triez les lignes de texte alphabétiquement, numériquement ou par longueur — avec options d'inversion et de casse. S'exécute dans votre navigateur.`)
};

const it_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinatore di linee gratuito. Ordina le righe di testo alfabeticamente, numericamente o per lunghezza — con opzioni di inversione e maiuscole. Funziona nel tuo browser.`)
};

const pt_br2_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenador de linhas gratuito. Ordene linhas de texto alfabética, numérica ou por comprimento — com opções de reversão e maiúsculas/minúsculas. Funciona no seu navegador.`)
};

const pt_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificador de linhas gratuito. Classifique linhas de texto alfabeticamente, numericamente, ou por comprimento — com opções de inversão e maiúsculas/minúsculas. Funciona no seu navegador.`)
};

const ja_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の行ソーター。テキストの行をアルファベット順、数値順、または長さでソート——逆順と大文字小文字オプション付き。ブラウザで実行できます。`)
};

const zh_ls_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的行排序工具。按字母顺序、数字顺序或行长度对文本行排序——支持反向排序和大小写选项。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_tool_description", locale)
	if (locale === "en") return en_ls_tool_description(inputs)
	if (locale === "es") return es_ls_tool_description(inputs)
	if (locale === "de") return de_ls_tool_description(inputs)
	if (locale === "nl") return nl_ls_tool_description(inputs)
	if (locale === "fr") return fr_ls_tool_description(inputs)
	if (locale === "it") return it_ls_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ls_tool_description(inputs)
	if (locale === "pt") return pt_ls_tool_description(inputs)
	if (locale === "ja") return ja_ls_tool_description(inputs)
	return zh_ls_tool_description(inputs)
};